import store from '../index';
import {
  addCentralizedError,
  showErrorModal,
} from '../slices/rackingInspectionSlice';
import { generateErrorId, extractOriginalMessage, ensureRetry } from './errorHandlerBase';

export const RACKING_INSPECTION_API_NAMES = {
  FETCH_INSPECTIONS: 'fetchRackingInspections',
  FETCH_METRICS: 'fetchRackingInspectionMetrics',
  CREATE_INSPECTION: 'createRackingInspection',
  UPDATE_INSPECTION: 'updateRackingInspection',
  DELETE_INSPECTION: 'deleteRackingInspection',
  DOWNLOAD_PDF: 'rackingInspectionDownloadPDF',
  FETCH_FILTERS: 'fetchRackingInspectionFilters',
  FETCH_DAMAGE_CHECKLIST: 'fetchRackingInspectionDamageChecklist',
} as const;

export const getUserFriendlyErrorMessage = (apiName: string, originalMessage?: string): string => {
  const friendly: Record<string,string> = {
    [RACKING_INSPECTION_API_NAMES.FETCH_INSPECTIONS]: 'Unable to load racking inspections. Please try again.',
    [RACKING_INSPECTION_API_NAMES.FETCH_METRICS]: 'Unable to load racking inspection metrics. Please try again.',
    [RACKING_INSPECTION_API_NAMES.CREATE_INSPECTION]: 'Unable to create inspection. Please try again.',
    [RACKING_INSPECTION_API_NAMES.UPDATE_INSPECTION]: 'Unable to update inspection. Please try again.',
    [RACKING_INSPECTION_API_NAMES.DELETE_INSPECTION]: 'Unable to delete inspection. Please try again.',
    [RACKING_INSPECTION_API_NAMES.DOWNLOAD_PDF]: 'Unable to download inspection PDF. Please try again.',
    [RACKING_INSPECTION_API_NAMES.FETCH_FILTERS]: 'Unable to load racking inspection filter options. Please try again.',
    [RACKING_INSPECTION_API_NAMES.FETCH_DAMAGE_CHECKLIST]: 'Unable to load racking damage checklist. Please try again.',
  };
  return friendly[apiName] || `An error occurred. ${originalMessage || 'Please try again.'}`;
};

export const handleRackingInspectionErrorWithFriendlyMessage = (
  apiName: string,
  error: any,
  displayModal: boolean = true,
  context: any = {}
) => {
  const originalMessage = extractOriginalMessage(error);
  const friendlyMessage = getUserFriendlyErrorMessage(apiName, originalMessage);

  const centralizedError = {
    id: generateErrorId(),
    message: ensureRetry(friendlyMessage),
    details: originalMessage,
    apiName,
    timestamp: Date.now(),
    context,
  };

  try {
    store.dispatch(addCentralizedError(centralizedError));
    if (displayModal) {
      store.dispatch(showErrorModal(centralizedError));
    }
  } catch (e) {
    console.error('[RackingInspection Error] failed to dispatch centralized error:', e);
  }

  console.error(`[RackingInspection Error] ${apiName}:`, { message: friendlyMessage, errorId: centralizedError.id, originalError: error, context });

  return centralizedError;
};
